import Instructions from './Instructions';
import IntlWrapper from 'components/layout/intlWrapper';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import Report from './Report';
import routeUtils from 'util/routeUtils';
import Split from './Split';
import toolFlow from 'helpers/toolFlow';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {Header} from 'components/layout';
import {router, events} from 'lib';

// Register in router
let render = (container, params) => {
  console.info('[UI.page.tools.accounts.split-contacts] rendering page');
  ReactDOM.render(<IntlWrapper><WrapperSplitContactsContainer page={params.page || 0} /></IntlWrapper>, container);
  events.publish('page-change', {page: 'tools'});
};

console.info('[UI.page.tools.accounts.split-contacts] register route');
router.rr.add([{path: 'tools/accounts/split-contacts/:page', handler: routeUtils.requireAuth(render)}]);

const propTypes = {
  View: PropTypes.any.isRequired,
  setPage: PropTypes.func.isRequired,
};

class SplitContacts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedContact: null,
      results: [],
      search: '',
      blacklist: new Set(),
    };
  }

  setResults = res => {
    this.setState({results: res});
  };

  setSearch = search => {
    this.setState({search});
  };

  addToBlacklist = id => {
    let blacklist = this.state.blacklist.add(id);

    this.setState({blacklist});
  };

  selectContact = id => {
    this.setState({
      selectedContact: id,
    });
    this.props.setPage(2);
  };

  /**
   * Updates results after a merge and return to report list.
   * @param  {function} f Function on results that returns new results value.
   * @return {undefined}
   */
  updateResults = f => {
    const results = f(this.state.results);

    this.setState({results});
    this.props.setPage(1);
  };

  render() {
    let {View} = this.props;
    let {formatMessage} = this.props.intl;

    return <div className='container'>
      <Header mainTitle={formatMessage({id: 'general.accounts'})} maintTitleReturn='#tools/accounts' subTitle={formatMessage({id: 'tools.split.contact.two'})} />
      <View
        selectedContact={this.state.selectedContact}
        results={this.state.results}
        setResults={this.setResults}
        selectContact={this.selectContact}
        setSearch={this.setSearch}
        search={this.state.search}
        blacklist={this.state.blacklist}
        addToBlacklist={this.addToBlacklist}
        updateResults={this.updateResults}
        cancelSplit={() => this.props.setPage(1)}
       />
    </div>;
  }
}
SplitContacts.displayName = 'SplitContacts';
SplitContacts.propTypes = propTypes;

const SplitContactsContainer = toolFlow(SplitContacts, Instructions, Report, Split);

let WrapperSplitContactsContainer = injectIntl(SplitContactsContainer);
